import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import DJAreaChroma from './chroma';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/adminlte.css';
import './css/djarea.css';

export default class DJArea extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			mix365: {
				members: 0,
				djs: 0
			},
			facebook: 0,
			mixcloud: {
				clubbers: 0,
				radio: 0
			},
			twitch: {
				clubbers: 0,
				radio: 0
			},
			newdjs: {},
			newmembers: {},
			chroma: false,
		};
		this.access = this.access.bind(this);
		this.chroma = this.chroma.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params = new URLSearchParams();
		const x = await postApi('/api/v2/djarea/index', params);
		this.setState({mix365: x.data.mix365, facebook: x.data.facebook, mixcloud: x.data.mixcloud, twitch: x.data.twitch, newdjs: x.data.newdjs, newmembers: x.data.newmembers, status: true});
	}

	componentWillUnmount() {
	}

	async access() {
		if( window.confirm("Are you sure you wish to gain access?") ) {
			let params = new URLSearchParams();
			const x = await putApi('/api/v2/djarea/index', params);
			if( x.status === 200 ) window.location.href = "/";
		}
	}
	
	async chroma() {
		this.setState({chroma: !this.state.chroma});
	}

	close = (childData) => {
    this.setState({chroma: false});
	}

	render() {
		const user = this.context;
		const djs = 
      Object.keys(this.state.newdjs).map((e,i) => {
        return (
          <div key={i} className="col-12">
						<div className="dj-area-members">
							<div className="row">
								<div className="dj-area-members-avatar" style={{width: 60}}>
									<img src={`https://mix365.co.uk${this.state.newdjs[e].avatar}`} alt="profile avatar" />
								</div>
								<div className="col pt-2">
									<Link to={`/${this.state.newdjs[e].username.toLowerCase().replaceAll(' ','_')}`}>{this.state.newdjs[e].title ?
										<>
											{this.state.newdjs[e].title}&nbsp;<small>({this.state.newdjs[e].username})</small>
										</>
									:
										<>{this.state.newdjs[e].username}</>
									}
									</Link><br />
									{this.state.newdjs[e].level}
								</div>
							</div>
						</div>
					</div>
        )
      })
		const members = 
      Object.keys(this.state.newmembers).map((e,i) => {
        return (
          <div key={i} className="col-12">
						<div className="dj-area-members">
							<div className="row">
								<div className="dj-area-members-avatar" style={{width: 60}}>
									<img src={`https://mix365.co.uk${this.state.newmembers[e].avatar}`} alt="profile avatar" />
								</div>
								<div className="col pt-2">
									<Link to={`/${this.state.newmembers[e].username.toLowerCase().replaceAll(' ','_')}`}>{this.state.newmembers[e].title ?
										<>
											{this.state.newmembers[e].title}&nbsp;<small>({this.state.newmembers[e].username})</small>
										</>
									:
										<>{this.state.newmembers[e].username}</>
									}
									</Link><br />
									{this.state.newmembers[e].level}
								</div>
							</div>
						</div>
					</div>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				{this.state.status &&
					<Col>
						<Row>
							<Col>
								<div className="info-box">
									<span className="info-box-icon bg-info"><FontAwesomeIcon icon="user-group" /></span>
									<div className="info-box-content">
										<span className="info-box-number">Mix365</span>
										<span className="info-box-text">Members: {this.state.mix365.members}</span>
										<span className="info-box-text">DJ's: {this.state.mix365.djs}</span>
									</div>
								</div>
							</Col>
							<Col>
								<div className="info-box">
									<span className="info-box-icon bg-info"><FontAwesomeIcon icon={['fab', 'facebook-f']} /></span>
									<div className="info-box-content">
										<span className="info-box-number">Facebook</span>
										<span className="info-box-text">{this.state.facebook}</span>
										<span className="info-box-text">&nbsp;</span>
									</div>
								</div>
							</Col>
							<Col>
								<div className="info-box">
									<span className="info-box-icon bg-info"><FontAwesomeIcon icon={['fab', 'mixcloud']} /></span>
									<div className="info-box-content">
										<span className="info-box-number">Mixcloud</span>
										<span className="info-box-text">Clubbers: {this.state.mixcloud.clubbers}</span>
										<span className="info-box-text">Radio: {this.state.mixcloud.radio}</span>
									</div>
								</div>
							</Col>
							<Col>
								<div className="info-box">
									<span className="info-box-icon bg-info"><FontAwesomeIcon icon={['fab', 'twitch']} /></span>
									<div className="info-box-content">
										<span className="info-box-number">Twitch</span>
										<span className="info-box-text">Clubbers: {this.state.twitch.clubbers}</span>
										<span className="info-box-text">Radio: {this.state.twitch.radio}</span>
									</div>
								</div>
							</Col>
						</Row>
						<Row>
							<Col>
								<Row>
									{/*<Col xs={12}>
										<div className="card bg-dark">
											<div className="card-header">
												<h3 className="card-title">Announcement</h3>
												<div className="card-tools">
													<span className="badge badge-primary">+ Feed</span>
												</div>
											</div>
											<div className="card-body">
												Announcements
											</div>
											<div className="card-footer">
												Multiple streams
											</div>
										</div>
									</Col>*/}

									<Col xs={12}>
										<div className="card bg-dark">
											<div className="card-header">
												<h3 className="card-title">Facebook Messenger</h3>
											</div>
											<div className="card-body">
												We have two facebook messenger groups for technical issues and general chats, please if you are not subscribed please contact Simmy or Mattster to be added, We will require your facebook profile page and NOT a public page<br /><br />
												<strong>Mix365 Tech</strong> for technical issues and updates<br /><br />
												<strong>Mix365 Chats</strong> for general chatting
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card bg-dark">
											<div className="card-header">
												<h3 className="card-title">Test Centre</h3>
											</div>
											<div className="card-body">
												To help you get up and running, please use our test centre to ensure your video and audio settings are set up correctly
											</div>
											<div className="card-footer">
												<Link to="/djarea/test">Open Test Centre</Link>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card bg-dark">
											<div className="card-header">
												<h3 className="card-title">Schedule</h3>
											</div>
											<div className="card-body">
												To get started streaming here on Mix365, please head over to one on the scedules and book in your schedule entry
											</div>
											<div className="card-footer">
												<Link to="/clubbers/schedule">Mix365 Clubbers Schedule</Link> - <Link to="/radio/schedule">Mix365 Radio Schedule</Link>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card bg-dark">
											<div className="card-header">
												<h3 className="card-title">Mobile Web Chats</h3>
											</div>
											<div className="card-body">
												Better experience webchats on your mobile with our full mobile chats which can be either access from the andriod mobile app or using this address<br /><br />
												https://mix365.co.uk/mchat
											</div>
											<div className="card-footer">
												<a href="/mchat">Mobile Chats</a>
											</div>
										</div>
									</Col>

									{user.user.user.id === 2 &&
										<Col xs={12}>
											<div className="card bg-dark">
												<div className="card-body">
													<Button size="sm" onClick={()=>this.access()}>Temp admin access</Button>
												</div>
											</div>
										</Col>
									}

								</Row>
							</Col>
							<Col xs md={3}>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Newest DJ's</h3>
										<div className="card-tools">
											<span className="badge badge-primary">View all dj's</span>
										</div>
									</div>
									<div className="card-body">
										<Row>
											{djs}
										</Row>
									</div>
								</div>

								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Newest Members</h3>
										<div className="card-tools">
											<span className="badge badge-primary">View all members</span>
										</div>
									</div>
									<div className="card-body">
										<Row>
											{members}
										</Row>
									</div>
								</div>

							</Col>

							

							
						</Row>
						{this.state.chroma && <DJAreaChroma show={this.state.chroma} close={this.close} /> }
					</Col>
				}
			</Row>
		);
	}
}
